import cn from "classnames";
import IconSVG from "../../styles/svg-icons";
import { Pluralize } from "../common/Pluralize";
import { Badge } from "../common/Badge";

interface Props {
    iconVisible?: boolean;
    notesCount: number
    notesCountBadge?: boolean
    addNoteText?: React.ReactNode
    onClick?: () => void
}

export function ViewNotesButton({ notesCount, notesCountBadge = false, iconVisible = false, addNoteText = "Add", onClick }: Props) {
    return (
        <button onClick={onClick} className={cn("btn-link btn-notes", notesCount > 0 ? "pseudo-link" : "bold")}>
            {iconVisible && (
                <IconSVG name={notesCount > 0 ? 'notes' : 'add-notes'} width={16} height={16} />
            )}
            {notesCount ? (
                <>
                    <Pluralize singular="Note" count={notesCount} template="{{text}}" />
                    {notesCountBadge ? <Badge value={notesCount} /> : <> ({notesCount})</>}
                </>) : addNoteText}
        </button>
    );
}